export default __webpack_public_path__ + "static/media/right-ar.43b18bb0.svg";